module.exports = __webpack_public_path__ + "img/icons_dotted.400bf56d.svg";